var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CanvasOverlay } from "../overlay-elements/canvas-overlay";
import * as Styled from "./grip-frame-turn-control.style";
import { EditButtons, EditButtonIcon, } from "ui/components/elements/edit-buttons/edit-buttons";
import { useAppSelector, useAppDispatch, selectors, actions } from "store";
import { useWorldScreenPosition } from "hooks/playcanvas/world-screen-position";
import { buildGripFrameHandle, gripFrameY } from "3d/grip-frame";
/**
 * The turn control of the selected frame ("grimma"): one button beside the
 * frame's drag handle that turns the cups a quarter turn clockwise — and, once
 * turned, the opposite button that turns them back. The frame never turns any
 * further than that one step (see `turnGripFrame`).
 *
 * Shown while the frame is selected, which clicking or dragging its handle
 * does (hidden for the drag itself, then back beside the handle on release).
 * It stays selected across a turn, so the turn back is one more click; the
 * control follows the handle to the turned frame's upper-left corner.
 */
export var GripFrameTurnControl = function (_a) {
    var app = _a.app;
    var frame = useAppSelector(selectors.selectGripFrame);
    var isSelected = useAppSelector(selectors.selectIsGripFrameSelected);
    if (!frame || !isSelected)
        return null;
    return _jsx(TurnButton, { app: app, frame: frame });
};
var TurnButton = function (_a) {
    var app = _a.app, frame = _a.frame;
    var dispatch = useAppDispatch();
    var isTurned = useAppSelector(selectors.selectIsGripFrameTurned);
    /* Anchored on the right-hand edge of the handle, so the button sits next to
     * the move icon rather than on top of it. */
    var handle = buildGripFrameHandle(frame);
    var _b = __read(handle.position, 3), handleX = _b[0], handleZ = _b[2];
    var position = useWorldScreenPosition(app, frame.center.x + handleX + handle.scale[0] / 2, gripFrameY, frame.center.z + handleZ);
    if (!position)
        return null;
    return (_jsx(CanvasOverlay, { x: position.x, y: position.y, children: _jsx(Styled.TurnControl, { children: _jsx(EditButtons, { hasBackground: true, actions: [
                    {
                        icon: isTurned
                            ? EditButtonIcon.ROTATE_COUNTER_CLOCKWISE
                            : EditButtonIcon.ROTATE_CLOCKWISE,
                        action: function (event) {
                            event.stopPropagation();
                            dispatch(actions.turnGripFrame());
                        },
                    },
                ] }) }) }));
};
